/**
 * Leser api-versjon headere fra respons og broadcaster event dersom klient er utdatert.
 */
import {IHttpInterceptor, IHttpProvider, IHttpResponse, IPromise, IScope, ITimeoutService} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";
import {Debugger} from "debug";
import _ from "lodash"

const debug: Debugger = require('debug')('ApiVersjonResponsHeadereInterceptor');

export var klientUtdatertEvent = "httpProvider:klientUtdatertEvent";

export function registrerApiVersjonResponsHeadereInterceptor($httpProvider: IHttpProvider) {

    const apiVerHeader = 'X-lpApiVer';
    const klientUtdatertHeader = 'X-lpKlientUtdatert';

    /** Hvor mange millisekunder vi venter fra vi mottar en respons som indikerer at klient relastes, til vi varsler bruker om at dette bør gjøres.
     * Vi varsler IKKE bruker umiddelbart pga rullende deploy av lederplan-tjenester.
     * Dette da det i periode fra første node er oppdatert til ny versjon, til siste node med gammel versjon er tatt ned blir tilfeldig hvilken versjon
     * av klienten (gammel eller ny) bruker vil laste ned ved relasting i nettleser. Det er ført når siste node med gammel versjon er tatt ned at vi
     * kan garantere at ny versjon vil bli servert ved relasting. */
    const antallSekunderFørKlientUtdatertEventBroadcastes = 60*3; //3 minutter

    var responsInterceptor = ($rootScope: IScope, $timeout: ITimeoutService) => {

        /** Sann dersom vi har mottar en respons som indikerer at klient relastes, men enda ikke broadcastet klientUtdatertEvent */
        let ventendeBroadcastEksisterer = false;

        function broadcastKlientUtdatertEvent(){
            debug('klient utdatert, broadcaster event "httpProvider:klientUtdatertEvent"');
            $rootScope.$broadcast(klientUtdatertEvent);
            ventendeBroadcastEksisterer = false
        }

        return <IHttpInterceptor>{
            response: function (response: IHttpResponse<any>) {
                //console.debug('responsInterceptor X-lpApiVer', response.headers('X-lpApiVer'));
                //console.debug('responsInterceptor X-lpKlientUtdatert', response.headers('X-lpKlientUtdatert'));
                //console.debug('responsInterceptor Cache-Control', response.headers('Cache-Control'));

                //ignorer X-lpKlientUtdatert dersom respons skal caches
                const hensyntaKlientUtdatertHeader = _.includes(response.headers('Cache-Control'), 'no-store')
                const klientUtdatert = response.headers(klientUtdatertHeader) === 'true';
                if (hensyntaKlientUtdatertHeader && klientUtdatert) {
                    if (ventendeBroadcastEksisterer){
                        debug('klient utdatert, med det er allerede registrert et broadcast promise')
                    } else {
                        debug(`klient utdatert, registrert et broadcast promise som resolver om ${antallSekunderFørKlientUtdatertEventBroadcastes} sekunder`)
                        $timeout(() => broadcastKlientUtdatertEvent(), antallSekunderFørKlientUtdatertEventBroadcastes * 1000);
                        ventendeBroadcastEksisterer = true
                    }
                }

                return response;
            }
        };
    };

    $httpProvider.interceptors.push([regNavn.ng.$rootScope, regNavn.ng.$timeout, responsInterceptor]);
}

export function registrerApiVersjonResponsHeadereInterceptorForInjisering() {
    return [
        regNavn.ng.$httpProvider,
        registrerApiVersjonResponsHeadereInterceptor
    ];
}
